import React, { useEffect, useState } from "react";
import Config from "../Config";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useAuthHandling } from '../useAuthhandling';
import Deletemodal from "../Deletemodal";

function Newslist() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [newslist, setNewslist] = useState([]);

  const [modal_animationFlip, setmodal_animationFlip] = useState(false);
  const [pageid, setPageid] = useState("");

  function tog_animationFlip(id) {
    setmodal_animationFlip(!modal_animationFlip);
    setPageid(id)
  }
  const getinfo = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/news/get-news`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
      },
    });
    if (res.status === 200) {
      const data = await res.json();

      setNewslist(data.data);

    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };
  useEffect(() => {
    getinfo();
  }, []);

  const DeleteData = async (id) => {
    setmodal_animationFlip(false);

    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/news/delete-news/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );


    if (response.status === 200) {
      const deletedata = await response.json();

      toast.success("Sucessfully deleted", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      getinfo();
    }
    else if(response.status === 401){
      handleUnauthorized();
      DeleteData(id);
    }
    else {
     
    }
  };

  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        {/* partial */}
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">News List</h4>
                    <div className="table-responsive pt-3">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Sl.no</th>
                            <th>Title</th>
                            <th>Slug</th>

                            <th>Author</th>

                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {newslist.map((element, i) => {
                            return (
                              <>
                                <tr>
                                  <th scope="row">{i + 1}</th>
                                  <td>{element.title}</td>

                                  <td>{element.slug}</td>
                                  <td>{element.author}</td>

                                  <td className="">
                                    <button
                                      // onClick={() => deletenews(element._id)}
                                      onClick={() => tog_animationFlip(element._id)}

                                      className="margins-2"
                                    >
                                      <i className="fa-solid fa-trash" />
                                    </button>
                                    <button>
                                      <Link
                                        to={"/editnews/" + element._id}
                                        className="fa-solid fa-pen"
                                        style={{ color: "black" }}
                                      ></Link>
                                    </button>
                                    <ToastContainer />
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modal_animationFlip ? (
          <Deletemodal
            modal_animationFlip={modal_animationFlip}
            tog_animationFlip={tog_animationFlip}
            pageid={pageid}
            DeleteData={DeleteData}
            message={"News"}
          />
        ) : (
          ""
        )}
    </div>
  );
}

export default Newslist;
